/* import __COLOCATED_TEMPLATE__ from './earn-badge.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
}

const EarnBadge = templateOnlyComponent<Signature>();
export default EarnBadge;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Referrals::EarnBadge': typeof EarnBadge;
    'new-settings/workspace/referrals/earn-badge': typeof EarnBadge;
  }
}
